export var ChainType;
(function (ChainType) {
    ChainType["Solana"] = "solana";
    ChainType["Ethereum"] = "ethereum";
})(ChainType || (ChainType = {}));
export var ConnectionState;
(function (ConnectionState) {
    ConnectionState["Connected"] = "connected";
    ConnectionState["Connecting"] = "connecting";
    ConnectionState["Disconnected"] = "disconnected";
    ConnectionState["Disconnecting"] = "disconnecting";
})(ConnectionState || (ConnectionState = {}));
